import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import { MediaPlayerContext } from "./MediaPlayerContext";

export const useMediaPlayer = () => {
  const context = useContext(MediaPlayerContext);

  if (!context) {
    throw new HookOutOfContextError("useMediaPlayer", "MediaPlayerContext");
  }

  return context;
};
